const Separator = '/';

//Page name only
export const Page = {
  // Pages
  Home: '',
  AboutUs: 'about-us',
  HowItWorks: 'how-it-works',
  PilotProgram: 'pilot-program',
  Solutions: 'solutions',
  TermsAndConditions: 'terms-and-conditions',
  PrivacyPolicy: 'privacy-policy',
  ContactUs: 'contact-us',
};

//Full url of each Page
export const AmacUrl = {
  Home: Separator + Page.Home
};
